import { Injectable } from '@angular/core';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Alert, AlertFlashService } from '@callrail/looky/ui';
import { AppRoutes, LocationService } from '@callrail/looky/util';
import { Auth, Hub } from 'aws-amplify';
import { CognitoCookieService } from '../cognito-cookie/cognito-cookie.service';

@Injectable({
  providedIn: 'root',
})
export class UserSignoutService {
  private cognitoUser: boolean;
  private redirectRoute: string;

  private hubListenerCancelToken: () => void;

  constructor(
    private readonly authenticator: AuthenticatorService,
    private readonly locationService: LocationService,
    private cognitoCookieService: CognitoCookieService,
    private alertService: AlertFlashService
  ) {
    this.cognitoUser = this.authenticator.authStatus === 'authenticated';

    if (this.cognitoUser) {
      this.redirectRoute = '/authenticate';
    } else {
      this.redirectRoute = '/users/sign_out';
    }
  }

  public userSignout(): void {
    this.cognitoCookieService.signOut();
    if (this.cognitoUser) {
      this.signoutCognito();
    } else {
      this.standardSignout();
    }
  }

  public userTimeout(): void {
    if (this.cognitoUser) {
      this.alertService.addAlert(
        new Alert({
          type: 'info',
          text: 'Your session expired. Please sign in again to continue.',
          crossApp: true,
          app: AppRoutes.ANUBIS,
        })
      );
      this.signoutCognito();
    } else {
      this.standardSignout();
    }
  }

  private standardSignout(): void {
    if (this.hubListenerCancelToken) {
      this.hubListenerCancelToken();
    }

    this.locationService.go(this.redirectRoute, true);
  }

  private signoutCognito(): void {
    this.hubListenerCancelToken = Hub.listen('auth', (data) => {
      if (data?.payload?.event === 'signOut') {
        this.standardSignout();
      }
    });
    Auth.signOut({ global: true }).catch((error) => {
      // if token has been revoked, signout will continue
      this.authenticator.signOut();
      this.standardSignout();
    });
  }
}
